import { useEffect, RefObject } from "react"

export function useCloseOnScrollOutOfView(open: boolean, setOpen: (open: boolean) => void, anchorRef: RefObject<HTMLDivElement | null>) {
  useEffect(() => {
    if (!open || !anchorRef.current) return

    // Close the panel when the anchor is scrolled out of view
    const observer = new IntersectionObserver(
      ([entry]) => !entry.isIntersecting && setOpen(false),
      { threshold: 0 },
    )

    observer.observe(anchorRef.current)
    return () => observer.disconnect()
  }, [open, setOpen, anchorRef])
}
